import styled from "styled-components";

export const Wrapper = styled.div`
  perspective: 1000px;
`;

export const Card = styled.div<{ isFlipped: boolean }>`
  width: 100%;
  transform-style: preserve-3d;
  transition: transform 0.6s;
  position: relative;
  transform: ${({ isFlipped }) => (isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)')};
`;

const CardFace = styled.div`
  backface-visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const CardFront = styled(CardFace)``;

export const CardBack = styled(CardFace)`
  transform: rotateY(180deg);
`;

export const PaymentMethodSelector = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
  width: 100%;
`

export const PaymentMethodOption = styled.div<{ selected: boolean }>`
  flex: 1;
  padding: 1rem;
  border: 2px solid ${({ selected, theme }) => selected ? theme.colors.primary800 : theme.colors.gray300};
  border-radius: 8px;
  cursor: pointer;
  text-align: center;
  transition: all 0.2s ease-in-out;
  background-color: ${({ selected, theme }) => selected ? theme.colors.primary800 : 'transparent'};
  color: ${({ selected, theme }) => selected ? theme.colors.gray000 : theme.colors.text.primary};
  font-weight: ${({ selected }) => selected ? '600' : '400'};

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary700};
    background-color: ${({ selected, theme }) => selected ? theme.colors.primary700 : 'transparent'};
  }
`
